export type PhoneOS = 'android' | 'ios' | 'macOS' | 'windows' | 'unknown';

declare const window: Window &
  typeof globalThis & {
    MSStream: {};
  };

export function getOsFromUserAgent(UA?: string): PhoneOS {
  if (UA === undefined) {
    return 'unknown';
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(UA)) {
    return 'windows';
  }

  if (/android/i.test(UA)) {
    return 'android';
  }

  // Check for iOS devices including iPhone, iPod
  if (/iP(hone|od)/.test(UA) && !window.MSStream) {
    return 'ios';
  }

  // Check for iPad (works for older iPadOS)
  if (/iPad/.test(UA) && !window.MSStream) {
    return 'ios';
  }

  // Detect iPadOS 13+ (reports as macOS but has touch support)
  // Macs don't have touch support, but iPads do.
  if (
    /Macintosh/.test(UA) &&
    typeof navigator !== 'undefined' &&
    navigator.maxTouchPoints > 1
  ) {
    return 'ios';
  }

  return 'unknown';
}
